// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.h-table th, .h-table td {\n  overflow: inherit!important;\n}\n", ""]);
// Exports
module.exports = exports;
